module.exports = __webpack_public_path__ + "static/icon-calendar-364b2383778738aa7be19e50fee1f710.svg";